import { FormControl, FormGroup } from '@angular/forms';
import { SearchModelV2 } from '../search-model-v2';

/**
 * Search model for the role permission-set listings.
 *
 * Converted from the legacy SearchModel. The raw SQL it used to carry, kept here
 * because it is the only record of which column each field meant:
 *
 *   query:  (q) => q
 *     ? `(hdr.code ILIKE '%q%' OR hdr.name ILIKE '%q%') AND hdr.status!='DELETED'`
 *     : `hdr.status='DELETED'`
 *   table:  'app_perm_set_hdr'
 *   joins:  INNER JOIN app_perm_assignee_target_link link ON hdr.guid = link.perm_set_hdr_guid
 *           INNER JOIN app_perm_template_hdr template ON hdr.parent_guid = template.guid
 *   queryCallbacks: { permTemplate: t => `template.name ILIKE '%t%'` }
 *
 * The consuming components map those onto criteria the permission-set endpoint
 * understands: the keyword onto `search_word` (AppPermissionSetUow ILIKEs the
 * header's code and name) and permTemplate onto `perm_template` (which makes the
 * UoW join app_perm_template_hdr and ILIKE template.name itself).
 */
export const RolePermSetListingSearchModel: SearchModelV2 = {

    label: {
        permTemplate: 'Perm Template Name'
    },

    dataType: {
        permTemplate: 'string'
    },

    form: new FormGroup({
        permTemplate: new FormControl()
    }),

    options: {
        permTemplate: {}
    }

}
